import { trending, flashes } from '@/mocks/gossip';

export default function Trending() {
  return (
    <section id="hot" className="bg-background-50 py-14 md:py-20" aria-labelledby="hot-title">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-2 md:mb-10 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              <span className="inline-block h-px w-8 bg-primary-500"></span>
              Today&apos;s Hot Board
            </p>
            <h2 id="hot-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              今日热搜瓜榜
            </h2>
            <p className="mt-3 text-sm text-foreground-600 md:text-base">编辑实时盯榜，把此刻最热的话题一次性摆到你面前，排名随热度动态更替。</p>
          </div>
          <a
            href="#star"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            去明星八卦逛逛
            <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-5">
          {/* ranking list */}
          <div className="rounded-2xl border border-background-200 bg-background-100/60 p-4 md:p-5 lg:col-span-3">
            <div className="mb-4 flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-fire-fill text-primary-500" style={{ width: 20, height: 20, fontSize: 20 }} />
                实时热搜
              </h3>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
                <span className="relative flex h-1.5 w-1.5">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75"></span>
                  <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-primary-500"></span>
                </span>
                每 3 分钟更新
              </span>
            </div>

            <ol className="space-y-1">
              {trending.map((item, i) => (
                <li key={item.rank}>
                  <button
                    type="button"
                    onClick={() => {
                      const sec = item.tag === '综艺' || item.tag === '明星' || item.tag === '影视' || item.tag === '音乐' || item.tag === '演出' ? 'star' : 'social';
                      document.getElementById(sec)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="group flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left transition-colors hover:bg-background-50"
                  >
                    <span
                      className={`font-heading w-7 shrink-0 text-center text-lg font-black ${
                        i < 3 ? 'text-primary-500' : 'text-foreground-300 group-hover:text-foreground-400'
                      }`}
                    >
                      {String(item.rank).padStart(2, '0')}
                    </span>
                    <span className="line-clamp-1 flex-1 text-sm font-medium text-foreground-800 group-hover:text-primary-700">
                      {item.title}
                    </span>
                    <span className="hidden shrink-0 whitespace-nowrap rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-700 sm:inline-block">
                      {item.tag}
                    </span>
                    {item.delta === 'up' && <i className="ri-arrow-up-line shrink-0 text-xs text-primary-500" style={{ width: 14, height: 14 }} />}
                    {item.delta === 'down' && <i className="ri-arrow-down-line shrink-0 text-xs text-foreground-400" style={{ width: 14, height: 14 }} />}
                    {item.delta === 'flat' && <i className="ri-subtract-line shrink-0 text-xs text-foreground-400" style={{ width: 14, height: 14 }} />}
                  </button>
                </li>
              ))}
            </ol>
          </div>

          {/* right flashes + quick stats */}
          <div className="flex flex-col gap-5 lg:col-span-2">
            <div className="flex-1 rounded-2xl border border-background-200 bg-background-100/60 p-4 md:p-5">
              <h3 className="mb-4 flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-broadcast-line text-accent-600" style={{ width: 20, height: 20, fontSize: 20 }} />
                热点快讯
              </h3>
              <ul className="space-y-0">
                {flashes.map((f, i) => (
                  <li key={f.time} className="flex gap-3 border-b border-background-200/70 py-3 last:border-0">
                    <span className="shrink-0 pt-0.5 whitespace-nowrap font-mono text-xs font-semibold text-accent-700">{f.time}</span>
                    <p className="text-sm leading-relaxed text-foreground-700">{f.text}</p>
                  </li>
                ))}
              </ul>
            </div>

            <div className="overflow-hidden rounded-2xl bg-gradient-to-br from-primary-500 to-primary-700 p-5 md:p-6">
              <h3 className="font-heading text-lg font-bold text-background-50">追瓜要有章法</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-50/85">
                与其在信息洪流里东翻西找，不如订阅吃瓜视界的栏目速递，把最新瓜料一次看个够。
              </p>
              <a
                href="#feature"
                className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-semibold text-primary-600 transition-colors hover:bg-background-100"
              >
                看编辑精选
                <i className="ri-arrow-right-line" style={{ width: 15, height: 15 }} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}